import { useState } from "react";
import urls from "../constants";
import { useFetch } from "./useFetch";

export function useInterpretations() {
    const { sendGet, sendPost } = useFetch();
    const [interpretations, setInterpretations] = useState([]);

    const getInterpretations = async (token) => {
        try {
            const response = await sendGet(urls.GET_INTERPRETATIONS, {
                AccessToken: token
            });
            const data = response.map(item => normaliseInterpretation(item));  
            setInterpretations(data);         
            return data;
        } 
        catch (error) {
            console.error(error);
            setInterpretations([]);
            return [];
        }
    }

    const getVideo = async (token, videoID) => {
        try {
            const response = await sendGet(`${urls.GET_VIDEO}&videoID=${videoID}`, {
                AccessToken: token
            });       
            return response;
        } 
        catch (error) {
            console.error(error);
            return null;
        }
    }

    const normaliseInterpretation = (interpretationItem) => {
        interpretationItem.PublishedDate = new Date(interpretationItem.PublishedDate);
        const languages = Object.keys(interpretationItem.Interpretations)
        languages.forEach(language => {
            interpretationItem.Interpretations[language].Timestamp = new Date(interpretationItem.Interpretations[language].Timestamp);
        });
        return interpretationItem;
    }

    const addInterpretation = async (token, videoID, videoTitle, publishedDate, language, filename, file) => {
        try {
            let haveExisting = false;
            const interpretationIndex = interpretations.findIndex(i => i.VideoID === videoID);
            if(interpretationIndex >= 0 && interpretations[interpretationIndex].Interpretations[language]) {
                haveExisting = true;
            }
            if(!haveExisting) {
                const interpretation = await sendPost(urls.ADD_INTERPRETATION, {
                        AccessToken: token
                    },
                    JSON.stringify({ videoID, language, filename, file })
                );
                interpretation[language].Timestamp = new Date(interpretation[language].Timestamp)
                const interpretationsCopy = [...interpretations];
                if(interpretationIndex < 0) {
                    const languageInterpretations = {};
                    languageInterpretations[language] = interpretation[language];
                    interpretationsCopy.push({VideoID: videoID, VideoTitle: videoTitle, PublishedDate: publishedDate, Interpretations: languageInterpretations});
                }
                else {
                    const existingInterpretation = {...interpretations[interpretationIndex]};
                    existingInterpretation.Interpretations[language] = interpretation[language];
                    interpretationsCopy[interpretationIndex] = existingInterpretation;
                }
                setInterpretations(interpretationsCopy);
                return true;
            }
            else {
                alert('There is an existing interpretation for this language and video, please remove it first');                
                return false;
            }
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    const removeInterpretation = async (token, videoID, language) => {
        try {
            await sendPost(`${urls.REMOVE_INTERPRETATION}&videoID=${videoID}&language=${language}`, {
                    AccessToken: token
                }
            );
            setInterpretations(interpretations.map(interpretationItem => {
                if(interpretationItem.VideoID === videoID) {
                    const interpretations = {...interpretationItem.Interpretations};
                    delete interpretations[language];
                    return {
                        ...interpretationItem,
                        Interpretations: interpretations
                    };
                }
                else {
                    return interpretationItem;
                }
            }));
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    return { getInterpretations, getVideo, interpretations, addInterpretation, removeInterpretation };
}